export default __webpack_public_path__ + "static/media/user_icon.eee9c3fd.svg";